module.exports = __webpack_public_path__ + "img/80.10.pH.a8cf4ae3.png";